import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { fetchAvailability, setCapacity, formatApiError } from "@/lib/adminApi";

export function CapacityCard({ refreshKey }) {
  const [a, setA] = useState(null);
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  const load = () =>
    fetchAvailability()
      .then((d) => {
        setA(d);
        setValue(String(d.capacity));
      })
      .catch(() => {});

  useEffect(() => {
    load();
  }, [refreshKey]);

  const save = async () => {
    setSaving(true);
    try {
      const d = await setCapacity(Number(value));
      setA(d);
      toast.success(`Kapacita nastavena na ${d.capacity} míst týdně.`);
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  const pct = a && a.capacity ? Math.min(100, Math.round((a.booked / a.capacity) * 100)) : 0;

  return (
    <div className="bg-brand-surface border border-brand-accent/40 p-5" data-testid="capacity-card">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-brand-muted">Volná místa tento týden (živě na webu)</div>
          <div className="mt-2 font-display font-black text-3xl leading-none">
            <span className="text-brand-accent" data-testid="capacity-remaining">{a ? a.remaining : "—"}</span>
            <span className="text-brand-muted text-base font-normal"> / {a ? a.capacity : "—"} · obsazeno {a ? a.booked : "—"}</span>
          </div>
          {a && (
            <div className="mt-1.5 text-xs text-brand-muted">
              Týden {a.week_start} – {a.week_end} · počítají se nezrušené rezervace přijaté tento týden
            </div>
          )}
          <div className="mt-3 h-1.5 w-full max-w-xs bg-brand-border">
            <div className="h-full bg-brand-accent transition-all" style={{ width: `${pct}%` }} />
          </div>
        </div>
        <div className="flex items-end gap-2">
          <label className="text-[10px] uppercase tracking-[0.25em] text-brand-muted block">
            Kapacita / týden
            <input
              type="number"
              min={0}
              max={999}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              data-testid="capacity-input"
              className="mt-1 block w-24 h-9 bg-brand-bg border border-brand-border text-white text-sm px-3 focus:outline-none focus:ring-1 focus:ring-brand-accent"
            />
          </label>
          <button
            onClick={save}
            disabled={saving || value === "" || Number(value) === a?.capacity}
            data-testid="capacity-save"
            className="h-9 px-4 bg-brand-accent text-black text-xs font-semibold hover:bg-brand-accentHover transition-colors disabled:opacity-50"
          >
            {saving ? "Ukládám..." : "Uložit"}
          </button>
        </div>
      </div>
    </div>
  );
}
